import { render, staticRenderFns } from "./MainSideBarCompressed.vue?vue&type=template&id=3fd20a96&scoped=true"
import script from "./MainSideBarCompressed.vue?vue&type=script&lang=js"
export * from "./MainSideBarCompressed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd20a96",
  null
  
)

export default component.exports